// Packages
import { compose } from "@invrs/helpers/dist/compose"
import DotStore from "dot-store"
import withIframe from "dot-store-iframe"
import withMessage from "dot-store-message"

// Constants
export const store = compose(
  withMessage("article"),
  withIframe("article")
)(new DotStore())
